module.exports = __webpack_public_path__ + "static/media/怡澜风采.3fbe4e02.jpg";